var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"heading-logo",attrs:{"src":require("../assets/mci_logo_square_colored.jpeg"),"alt":"Moc Chau Island"}})
}
var staticRenderFns = []

export { render, staticRenderFns }